import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import { initSentryMonitoring } from './utils/sentryMonitoring';
import { installProductionConsoleGuard } from './utils/productionConsoleGuard';
import { installGlobalClientIssueHandlers } from './utils/clientIssueReporter';

installProductionConsoleGuard();
initSentryMonitoring();
installGlobalClientIssueHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);
